import React from "react";

import { type GetLabelRuleGroupsV3_me_labelRuleGroupsV3 } from "@north-beam/nb-client-side";

import { BreakdownItem } from "./breakdown-item";

interface Props {
  breakdowns: GetLabelRuleGroupsV3_me_labelRuleGroupsV3[];
}

export const BreakdownList = ({ breakdowns }: Props) => {
  return (
    <div className="space-y-2">
      {breakdowns.map((e) => (
        <BreakdownItem key={e.id} breakdown={e} />
      ))}
    </div>
  );
};
